/** Extract plain text from BlockNote block array for search */
export function blocksToText(blocks: unknown[]): string {
  if (!blocks || !blocks.length) return '';
  const parts: string[] = [];
  function walk(node: unknown) {
    if (!node || typeof node !== 'object') return;
    const n = node as Record<string, unknown>;
    if (typeof n.text === 'string') parts.push(n.text);
    if (Array.isArray(n.content)) n.content.forEach(walk);
    if (Array.isArray(n.children)) n.children.forEach(walk);
  }
  blocks.forEach(walk);
  return parts.join(' ').toLowerCase();
}
